export const validEmail = (email) => {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return reg.test(email);
};

export const validPhone = (phone) => {
  return phone.match(/^(0)[1-9](\d{2}){4}/);
};

export const teamInputs = [
  {name: 'lastname', label: 'Nom *', placeholder: 'Dupont', type: 'text'},
  {name: 'firstname', label: 'Prénom *', placeholder: 'Jean', type: 'text'},
  {
    name: 'profession',
    label: 'Rôle *',
    placeholder: 'Chef de projet',
    type: 'text',
  },
  {
    name: 'email',
    label: 'Email *',
    placeholder: 'dupontjean@leroymerlin.fr',
    type: 'email',
  },
  {
    name: 'phone',
    label: 'Téléphone *',
    placeholder: '00 00 00 00 00',
    type: 'text',
  },
];
